import { getCookie } from '$lib/utils/functions/getCookie';

export const getCustomerAccessToken = () =>
    new Promise((resolve) => {
        let token = getCookie('__storefrontAccessToken');
        if (token) {
            resolve(token);
        } else {
            fetch(`/api/auth/refreshToken`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin' })
                .then((r) => (r.ok ? r.json() : { data: {} }))
                .then((response) => {
                    resolve(response?.data?.token ?? 'null');
                })
                .catch((e) => {
                    resolve('null');
                });
        }
    });
